import { setDefaultAnimation } from '@shoelace-style/shoelace/dist/utilities/animation-registry.js';
import '@shoelace-style/shoelace/dist/themes/light.css'

export default () => {
  const modules = import.meta.glob('./*.ts');

  for (const path in modules) {
    // @ts-ignore
    modules[path]().then(({ default: mod }) => {
      if (!customElements.get(mod.component)) {
        customElements.define(mod.component, mod);
      }
    });
  }

  Promise.all([
    import('@shoelace-style/shoelace/dist/components/dropdown/dropdown.js'),
    import('@shoelace-style/shoelace/dist/components/select/select.js'),
    import('@shoelace-style/shoelace/dist/components/option/option.js'),
    import('@shoelace-style/shoelace/dist/components/menu/menu.js'),
  ]).then(() => {
    setDefaultAnimation('dropdown.show', null);
    setDefaultAnimation('dropdown.hide', {
      keyframes: [],
      options: {
        duration: 0
      }
    });
    setDefaultAnimation('select.show', null);
    setDefaultAnimation('select.hide', null);
  });
};
